<template>
  <a-popover
    v-model="visible"
    :visible-arrow="false"
    trigger="click"
    placement="bottom"
    popper-class="confirm-pop"
  >
    <div
      slot="content"
      class="pop-form-box"
    >
      <div class="pop-content pop-content2">
        <div class="untie-tip-box dialog-tip-box">
          <i class="icon iconfont iconicon-test68" />
          <h2>{{ title }}<span class=""> <a-tag>{{ name }}  {{ comname }}</a-tag></span></h2>
          <p
            v-if="bindId === 'bind_wechart'"
            class="d-tip-con"
          >
            {{ $t('message["516"]') }}
          </p>
          <p
            v-else
            class="d-tip-con"
          >
            {{ $t('message["479"]') }}？
          </p>
        </div>
      </div>
      <div class="pop-footer pop-footer2">
        <a-button
          type="primary"
          :disabled="submitting"
          @click="confirmHandle"
        >
          {{ $t('message["915"]') }}
        </a-button>
        <a-button
          @click="visible = false"
        >
          {{ $t('message["896"]') }}
        </a-button>
      </div>
    </div>
    <a
      v-if="isCanUnbind"
      class="unite-btn"
      @click.prevent="visible = true"
    >{{ $t('message["514"]') }}</a>
  </a-popover>
</template>
<script>
import { mapActions } from 'vuex'
// import Popup from '@/common/components/Popup'
export default {
  components: {
    // Popup
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    comname: {
      type: String,
      default: ''
    },
    bindId: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    isCanUnbind: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      submitting: false,
      visible: false
    }
  },
  computed: {
    // unbindUrl () {
    //   if (this.bindId === 'bind_gcw') {
    //     return '/user/user/unbindgcw'
    //   } else if (this.bindId === 'bind_dingding') {
    //     return '/user/user/unbinddt'
    //   } else if (this.bindId === 'bind_qiwei') {
    //     return '/user/user/unbindqw'
    //   } else {
    //     return ''
    //   }
    // }
  },
  methods: {
    ...mapActions('account/accountInfo', ['unBindQw', 'unBindGc', 'unbindWechat', 'unbindDingding']),
    async confirmHandle () {
      const { bindId } = this
      this.submitting = true
      if (bindId === 'bind_gcw') {
        const chain = await this.unBindGc()
        chain.params({ bindid: this.id })
          .onSuccess(raw => {
            this.visible = false
          })
          .fetch()
      } else if (bindId === 'bind_qiwei') {
        const chain = await this.unBindQw()
        chain.params({ bindid: this.id })
          .onSuccess(raw => {
            this.visible = false
          })
          .fetch()
      } else if (bindId === 'bind_dingding') {
        const chain = await this.unbindDingding()
        chain.params({ bindid: this.id })
          .onSuccess(raw => {
            this.visible = false
          })
          .fetch()
      } else {
        const chain = await this.unbindWechat()
        chain.params({ bindid: this.id })
          .onSuccess(raw => {
            this.visible = false
          })
          .fetch()
      }
      this.submitting = false
    }
  }
}
</script>
<style lang="scss">
.pop-form-box {
  .pop-content2 {
   min-width: 300px;
    margin-bottom: 24px;
  }
  .pop-footer2 {
    margin-left: 30px
  }
}

</style>
